import React, { useEffect, useState } from 'react'
import { InputField } from '../../components/Input'
import AuthLayout from '../../layouts/AuthLayout'
import { Link } from 'react-router-dom';
import { forgetPassword } from '../../adapters/authentication';
import forgetPasswordRequest from  '../../requests/forgotPassword';
import { ErrorStatus } from '../../components/FormStatus';

export default function ForgotPassword({ match }) {

  const [showStatus, setShowStatus] = useState(false);
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState(false);


  useEffect(() => {
    setTimeout(() => {
      setShowStatus(false);
    }, 3000)
  }, [showStatus])

  

  // const [status, setStatus] = useState('')

  const forgotPassword = async () => {
    setErrors([]);
    await forgetPasswordRequest.validate({email}).then(() => {
      forgetPassword(email).then((res) => {
        if(res.status === 200){
          setShowStatus(true);
          return ;
        }
        setErrors(['Record could not be found'])
      })
    }).catch((err) => {
      setErrors(err.errors);
    })
  }


  return (
    <AuthLayout title="Forgot Password">
      <ErrorStatus errors={errors} />
      {showStatus && <div className="py-3 mx-3 my-3 px-4 flex justify-start gap-3 items-center text-sm bg-green-200 rounded-lg font-semibold">
        <span className="text-green-700">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
          </svg>

        </span>
        <span>
          Instructions was sent to your mail successfully
        </span>
      </div>}
        <form onSubmit={(e)=> {
          e.preventDefault();
          forgotPassword();
        }}>
          <InputField type="email" placeholder="username@domain.com" onChange={(e) => {
            setErrors([])
            e.preventDefault();
            setEmail(e.target.value)
          }} defaultValue="" name="email" id="email" label="Email" />
          <div className="mt-6 px-3">
            <button className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg " type="submit">
              Send Reset Password Link
            </button>
            <Link to="/auth/sign-in" className="py-3 mt-2 font-fira hover:text-blue-900  text-sm font-semibold w-full text-center flex justify-center items-center text-blue-800 rounded-lg " type="submit">
              Sign In
            </Link>
          </div>
        </form>
    </AuthLayout>
  )
}
